<div [ngClass]="['cell', resourcesCssService.responsiveClass()]">
  <div class='badge'>
    <button (click)='play()'><i [ngClass]='icon'></i></button>
  </div>
  <div class='info'>
    <button (click)='play()'>{{ tool.name }}</button>
    <p class='description' [hidden]='!tool.description || tool.description.trim().length === 0' [innerHTML]="tool.description">{{ tool.description }}</p>
  </div>
</div>